// TAS-274: shown on a player's phone during TV-only phases (answer reveal,
// scoreboard, rating reveal, podium/leaderboard). In TV mode the big screen
// carries these moments and phones are just controllers — this keeps players
// oriented ("look up") without duplicating the reveal on the small screen.
import FullscreenLayout from '../FullscreenLayout';
import { Tv } from 'lucide-react';

/**
 * @param {string}  title    – headline, defaults to "Look at the big screen"
 * @param {string}  subtitle – contextual line (e.g. "Revealing the answer…")
 */
export default function LookAtScreen({ title = 'Look at the big screen', subtitle }) {
  return (
    <FullscreenLayout>
      <div className="relative flex min-h-[100dvh] flex-col items-center justify-center overflow-hidden bg-gradient-to-b from-tasted-green-deep via-wine-primary to-[#14301F] px-8 text-center">
        {/* Depth: soft dotted texture + a warm gold glow behind the icon */}
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,rgba(255,255,255,0.06)_1px,transparent_0)] bg-[length:40px_40px]" />
          <div className="absolute left-1/2 top-[38%] h-72 w-72 -translate-x-1/2 -translate-y-1/2 rounded-full bg-tasted-gold/15 blur-3xl" />
        </div>

        <div className="relative z-10 flex flex-col items-center gap-7">
          {/* Icon: gold-ringed for contrast pop against the deep green */}
          <div className="relative flex h-28 w-28 items-center justify-center rounded-full bg-tasted-gold/15 ring-1 ring-tasted-gold/40">
            <div className="flex h-20 w-20 items-center justify-center rounded-full bg-tasted-gold text-tasted-green-deep shadow-lg shadow-black/30">
              <Tv className="h-10 w-10" strokeWidth={2.25} />
            </div>
          </div>

          <div className="max-w-xs">
            <span className="mb-3 inline-block rounded-full bg-white/10 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.22em] text-tasted-gold-light ring-1 ring-white/15">
              TV Mode
            </span>
            <h1 className="font-display text-display-xl text-balance text-white drop-shadow-sm">{title}</h1>
            {subtitle && <p className="mt-2.5 font-display text-display-sm italic text-white/70">{subtitle}</p>}
          </div>

          <div className="mt-1 flex items-center gap-2">
            <span className="h-2 w-2 rounded-full bg-tasted-gold" />
            <span className="h-2 w-2 rounded-full bg-tasted-gold" />
            <span className="h-2 w-2 rounded-full bg-tasted-gold" />
          </div>
        </div>
      </div>
    </FullscreenLayout>
  );
}
